<template>
  <v-container class="not-found text-center">
    <h3 class="text-h3 mb-5">Esta Pagina no existe!</h3>
    <router-link :to="redirect" class="blue--text text-h6">Volver a casa</router-link>
  </v-container>
</template>

<script>
export default {
  computed: {
    loggedinUser() {
      return this.$store.getters['user/loggedinUser'];
    },
    redirect() {
      if (this.loggedinUser.isEditor) return '/dashboard/employee';
      return '/attend';
    },
  },
};
</script>

<style></style>
